import { computed } from "vue";
import { useStore } from "@/store"
import { ORGA_ROLES } from "./config/orga-roles";

export const useOrgaRoles = () => {
  const store = useStore();
  const orgaRole = computed(() => store.getters.orgaRole);

  return {
    isSuperAdmin: computed(() => store.getters.isSuperAdmin),
    isManager: computed(() => orgaRole.value === ORGA_ROLES.MANAGER),
    isAdmin: computed(() => orgaRole.value === ORGA_ROLES.ORG_ADMIN),
    isDashboardViewer: computed(() => orgaRole.value === ORGA_ROLES.DASHBOARD_VIEWER),
  }
};
